<template>
    <div class="sup-docs-api-comp" ref="ref_docs_content_comp">
        <DocsTitle class="content-title" :docs_api_data="docs_api_data" id="re_id_content_request_title"></DocsTitle>
        <DocsRequestHeader
            class="content-request-header"
            :docs_api_data="docs_api_data"
            id="re_id_content_request_header"
            v-if="request_gourp === $globalObj.group.service">
        </DocsRequestHeader>
        <DocsRequestBody class="content-request-body" :docs_api_data="docs_api_data" id="re_id_content_request_body"> </DocsRequestBody>
        <DocsResponseBody class="content-response-body" :docs_api_data="docs_api_data" id="re_id_content_response_body"> </DocsResponseBody>
        <DocsExampleMD
            class="content-example-md"
            id="re_id_content_example_md"
            :docs_content_type="$globalObj.docs_content_type.api"
            :md_content="docs_md_content"
            :update_md_data="update_md_data">
        </DocsExampleMD>
        <NextDocs :next_jump_curr_tree_node_id="api_comp_tree_node_id" />
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, getCurrentInstance, onBeforeUnmount, nextTick } from 'vue';
import DocsTitle from '@/components/Docs/DocsTitle.vue';
import DocsRequestHeader from '@/components/Docs/DocsRequestHeader.vue';
import DocsRequestBody from '@/components/Docs/DocsRequestBody.vue';
import DocsResponseBody from '@/components/Docs/DocsResponseBody.vue';
import DocsExampleMD from '@/components/Docs/DocsExampleMD.vue';
import NextDocs from '@/components/Common/NextDocs.vue';

import { getApiInfoByDocId } from '@/service/interface';
import { useStateStore } from '@/stores/state';
import { useMessageStore } from '@/stores/message';

const message_store = useMessageStore();
const state_store = useStateStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    api_comp_update_data: Function,
    request_gourp: Number,
    api_comp_tree_node_id: String,
});

const ref_docs_content_comp = ref(null);
const docs_md_content = ref(''); // markdown内容
const docs_api_data = ref({}); // api数据
const scroll_anchor_list = ref([]);

watch(
    () => props.api_comp_tree_node_id,
    (val) => {
        service_get_api();
    }
);

onMounted(() => {
    service_get_api();
    nextTick(() => {
        window.addEventListener('scroll', win_event_listen_scroll, true);
    });
});

onBeforeUnmount(() => {
    window.removeEventListener('scroll', win_event_listen_scroll);
});

// MARK Service  获取API文档
const service_get_api = () => {
    let params = {
        dcid: props.api_comp_tree_node_id,
    };
    proxy.$showLoading();
    getApiInfoByDocId({ params }).then((res) => {
        proxy.$hideLoading();
        let result = res.data;
        if (Object.keys(result).length !== 0) {
            docs_api_data.value = result;
            let content = result.apiModels && result.apiModels[0].content;
            // let replacedString = content.replace(/http:/g, 'https:');
            // docs_md_content.value = replacedString;
            docs_md_content.value = content;
            nextTick(() => {
                // 默认展示顶部
                ref_docs_content_comp.value.scrollTop = 0;
            });
        } else {
            docs_api_data.value = {};
            docs_md_content.value = '';
        }
    });
};
// MARK MD 更新数据
const update_md_data = (md_title_anchors) => {
    scroll_anchor_list.value = [];
    scroll_anchor_list.value = JSON.parse(JSON.stringify(proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_api_default_list));

    if (props.request_gourp === proxy.$globalObj.group.service) {
        let find = scroll_anchor_list.value.find((obj) => obj.anchorId == 're_id_content_request_header');
        if (!find) {
            scroll_anchor_list.value.splice(1, 0, { name: '请求头', level: 1, anchorId: 're_id_content_request_header', children: [] });
        }
    }

    if (md_title_anchors.length) {
        scroll_anchor_list.value.find((obj) => obj.anchorId === 're_id_content_example_md').children = [...md_title_anchors];
    }
    props.api_comp_update_data(scroll_anchor_list.value);
};

// MARK listen 滚动
const win_event_listen_scroll = () => {
    if (ref_docs_content_comp.value) {
        let scrollTop = ref_docs_content_comp.value.scrollTop;
        state_store.need_docsBreadcrumb_shadow = scrollTop > 0 ? true : false;
    }

    // 处理文档的锚点联动
    if (!state_store.scroll_anchor_click) {
        doc_scroll_anchor_update();
    } else {
        setTimeout(() => {
            state_store.scroll_anchor_click = false;
        }, proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_click_cancel_time);
    }
};

// 文档滚动触发锚点定位
const doc_scroll_anchor_update = () => {
    const default_anchorIds = proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_api_default_list.map((e) => `#${e.anchorId}`);
    const anchor_tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].concat(default_anchorIds);
    anchor_tags.forEach((tag) => {
        document.querySelectorAll(tag).forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top >= 0 && rect.top < proxy.$globalObj.scroll_anchor.__doc_scroll_anchor_top_api) {
                message_store.sendMessage(message_store.M_E_SCROLL_ANCHOR, { anchorId: element.id });
            }
        });
    });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-api-comp {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 42px;
    padding-right: 20px;
    box-sizing: border-box;

    .content-title {
        margin-top: 25px;
        width: 100%;
    }

    .content-request-header {
        margin-top: 24px;
        width: 100%;
    }

    .content-request-body {
        margin-top: 30px;
        width: 100%;
    }

    .content-response-body {
        margin-top: 30px;
        width: 100%;
    }

    :deep(.content-example-md) {
        margin-top: 30px;
        width: 100%;
        margin-bottom: 100px;

        .md-editor-preview {
            word-break: unset !important;
        }
    }
}
</style>
